import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as DocumentsActions,
  Selectors as DocumentsSelectors,
} from "store/ducks/documents";

import { Access } from "common";
import { Page, Panel, Loading, Breadcrumbs, Pagination } from "components";
import { Filters, Document } from "./components";

class List extends Component {
  constructor(props) {
    super(props);

    const { getDocumentsRequest } = props;

    this.handleSearchDocuments = debounce(getDocumentsRequest, 300);
  }

  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Documentos", to: "/documents" },
      { name: "Lista de Documentos", to: "" },
    ],
    filter: {
      store: Access.lockedStore()
        ? Access.lockedStore(true)
        : { value: "", label: "Todos" },
      status: { value: 'pendent', label: 'Pendente' },
      search: { value: "" },
      state: { value: "", label: "Todos" },
      start_date: null,
      end_date: null,
    },
    loading: false,
  };

  componentDidMount() {
    const { filter } = this.state;
    const { filters: filterRecover } = this.props.location;
    const { location, getDocumentsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    if (filterRecover) {
      this.setState({
        filter: filterRecover,
      });
    }

    getDocumentsRequest(page, filter);
  }

  async componentDidUpdate(oldProps) {
    const { filter, loading } = this.state;
    const { filters: filterRecover } = this.props.location;
    const { location, getDocumentsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getDocumentsRequest(queryString.parse(location.search).page, filter);
    }

    if (oldProps.location.filters !== undefined && !loading) {
      this.setState({
        filter: filterRecover,
        loading: true,
      });
      getDocumentsRequest(page, filter);
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;
    const { getDocumentsRequest } = this.props;

    await this.setState({ filter: { ...filter, [name]: value } });
    getDocumentsRequest(1, this.state.filter);
  };

  handleClean = async (e) => {
    e.preventDefault();
    const { getDocumentsRequest } = this.props;

    await this.setState({
      filter: {
        store: Access.lockedStore()
          ? Access.lockedStore(true)
          : { value: "", label: "Todos" },
        status: { value: "", label: "Todos" },
        search: { value: "" },
        state: { value: "", label: "Todos" },
        start_date: null,
        end_date: null,
      },
    });
    getDocumentsRequest(1, this.state.filter);
  };

  handleSearch = async (query) => {
    const { filter } = this.state;

    await this.setState({
      filter: {
        ...filter,
        search: {
          ...filter.search,
          value: query,
        },
      },
    });
    this.handleSearchDocuments(1, this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { documents } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Documentos</Page.Title>

        <Filters
          filter={filter}
          onChange={this.handleChangeFilter}
          onChangeInput={this.handleSearch}
          onClean={this.handleClean}
        />

        <Panel className="panel-list">
          {!documents.data.length && documents.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {documents.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>profissão</th>
                    <th>UF</th>
                    <th>CPF</th>
                    <th>documento</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!documents.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {documents.data.map((document) => (
                    <Document
                      document={document}
                      key={String(document.id)}
                      filters={filter}
                    />
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={documents.page}
                total={documents.totals}
                {...this.props}
              />

              {/* {Access.hasPermissions('edit-documents') && (
                <Link to="/documents/create" className="button-add">
                  Adicionar Document
                </Link>
              )} */}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = (state) => ({
  documents: {
    ...state.documents,
    data: DocumentsSelectors.documents(state.documents.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(DocumentsActions, dispatch);

export default connect(mapState, mapActions)(List);
